import { Alert } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { useCart } from "./cart.context";
import { CartHeader } from "./cart-header.component";
import { CartProgressBar } from "./cart-progress-bar.component";

export function CartLimitReached() {
	const { cartDisclosure, maxTotalCartQuantity } = useCart();

	const { t } = useTranslation(["cart"]);

	return (
		<>
			<div className="md:px-6">
				<CartHeader
					title={t("cart:yourCart")}
					onCloseButtonClick={cartDisclosure.close}
				/>
			</div>
			<div className="px-4 md:px-6">
				<Alert variant="warning" className="mt-4 p-6">
					<Alert.Description>
						<p className="text-body-bold">{t("cart:limit.reachedTitle")}</p>
						<br />
						<p>{t("cart:limit.reachedDescription")}</p>
					</Alert.Description>
				</Alert>

				<div className="mt-3 md:mt-6">
					<CartProgressBar />
				</div>
			</div>
		</>
	);
}
